'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-parse/lib/locate/escape.js
// module id = 913
// module chunks = 95715928098905 168707334958949